export const SUCCESS = 'success'
export const FAILURE = 'fail'